export default "__VITE_ASSET__I3fUgOY$__"